import PropTypes from 'prop-types';
import { ThemeColorsPropType } from '../../common/ThemeColors.js';

/** @typedef {import('../../common/ThemeColors.js').ThemeColors} ThemeColors */

/**
 * @typedef {Object} PtgFeaturesContextType
 * @property {string=} logoUrl
 * @property {string=} heading1
 * @property {string=} heading2
 * @property {string=} title
 * @property {string=} mainImageUrl
 * @property {string=} paragraph
 * @property {string=} featuresHeading
 * @property {string[]=} features
 * @property {string=} callToAction
 * @property {string=} qrUrl
 * @property {*} [footer] - passed through to EFlyerFooter which accepts an object/content
 * @property {ThemeColors=} themeColors - dealer's theme colors
 */
export const PtgFeaturesContextType = PropTypes.shape({
  logoUrl: PropTypes.string,
  heading1: PropTypes.string,
  heading2: PropTypes.string,
  title: PropTypes.string,
  mainImageUrl: PropTypes.string,
  paragraph: PropTypes.string,
  featuresHeading: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  callToAction: PropTypes.string,
  qrUrl: PropTypes.string,
  footer: PropTypes.any, // passed through to EFlyerFooter which accepts an object/content
  themeColors: ThemeColorsPropType
});
